import { useExportSignal } from 'features/pdfExport';
import { PdfExportTargets } from 'pages/Valuations/util/constants';

/**
 * PDF export v2 hidden iframes call `waitForReadiness` before `ValuationApproaches`
 * mounts. Summary targets already publish `loading` on `document.body` via
 * `useExportSignal` in `ValuationsAllocation`; approach-only targets did not, so
 * the capture pipeline hit the rAF "missing" fallback while `GridSkeleton` was
 * still showing (no `[data-ref]` yet). Bridge the same contract for every
 * approach-tab export target until outer valuation data has loaded.
 */
export const useBridgeApproachPdfExportSignals = (isExportMode: boolean, isOuterLoading: boolean) => {
  const enabled = isExportMode && isOuterLoading;

  useExportSignal({ target: PdfExportTargets.BACKSOLVE.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.BACKSOLVE_MARKET_ADJUSTMENT_LEDGER.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.EXTERNAL_VALUATION.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.PUBLIC_COMPS.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.DISCOUNTED_CASH_FLOW.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.FUTURE_EXIT.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.TRANSACTION_COMPS.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.SPECIFIED_SHARE_VALUES.id, status: 'loading', enabled });
  useExportSignal({ target: PdfExportTargets.CALIBRATION.id, status: 'loading', enabled });
};
